import { html } from "htm/preact/index.js";
import { useEffect, useRef } from "preact/hooks";
import { useComputed } from "@preact/signals";

import { useAppContext } from "src/services/context";
import ReservationSummary from "../summary/summary";
import settings from "src/services/settings";
import SvgIcon from "../svg-icon/svg-icon";

/**
 * @typedef {object} ConfirmationProps
 * @property {boolean} isVisible
 * @params {ConfirmationProps} props
 */
function Confirmation({ isVisible }) {
  const state = useAppContext();
  const containerRef = useRef(null);

  const reservationDate = useComputed(() => {
    return new Date(state.confirmedReservation.value?.date_time);
  });

  // Build the menu URL from the current restaurant page
  const menuUrl = `${window.location.origin}${window.location.pathname.replace(
    /\/$/,
    ""
  )}/menus/`;
  useEffect(() => {
    if (!isVisible) return;
  
    const resetScroll = () => {
      document.querySelectorAll(".moxies-opentable-content").forEach((el) => {
        el.scrollTop = 0;
      });
  
      const dialog = document.querySelector(".dialog-message.dialog-lightbox-message");
      if (dialog) {
        dialog.scrollTop = 0;
      }
    };
  
    requestAnimationFrame(() => {
      setTimeout(resetScroll, 0);
    });
  }, [isVisible]);

  if (isVisible && reservationDate.value.toString() === "Invalid Date") {
    return html`
      <div>
        There seems to be an error confirming your reservation.<br />
        If you do not receive a confirmation email from OpenTable within 15
        minutes, please contact the Moxies location you are booking at to
        confirm your reservation.
      </div>
    `;
  }

  return html`
    <div
      ref=${containerRef}
      class="mx-confirmation mx-reservation-form__step ${isVisible
        ? "mx-reservation-form__step--active"
        : ""}"
    >
      <header>
        <h2 class="mx-confirmation__title">Thanks for Booking</h2>
      </header>

      <${ReservationSummary}
        date=${reservationDate.value}
        partySize=${state.partySize.value}
        title=${state.selectedRestaurant.value.title.rendered}
      />

      <p>
        If you do not receive a confirmation email from OpenTable within 15
        minutes, please contact the Moxies location you are booking at to
        confirm your reservation.
      </p>
      <p class="confirmation__next-title">Want to plan your meal?</p>
      <div>
      <a
      class="moxies-button moxies-button-lg"
      href=${state.selectedRestaurant.value.link}menus/
    >

      <span class="moxies-button__bg"></span>
      <span class="moxies-button__label">
        See Menu
        <span class="moxies-button__icon">
          <${SvgIcon} icon=${settings.svgMenuIcon} />
        </span>
      </span>
    </a>

        <a
          style="width:100%"
          class="moxies-button moxies-button-lg moxies-button-white moxies-button-standard"
          target="_blank"
          href=${state.confirmedReservation.value?.manage_reservation_url}
        >
          <span class="moxies-button__bg"></span>
          <span class="moxies-button__label">
            Manage Reservation
          </span>
        </a>
      </div>
    </div>
  `;
}


export default Confirmation;